import "../css/Events.css";
import React, { useState, useEffect } from 'react';
import { Form, Button, Grid } from 'semantic-ui-react';

export default function EventPostComment({ eventid }) {
    const [rating, setRating] = useState();
    const [comment, setComment] = useState();
    const [commentExists, setCommentExists] = useState(false);
    const [commentPlaceholder, setCommentPlaceholder] = useState();
    const [ratingPlaceholder, setRatingPlaceholder] = useState();


    useEffect(() => {
        checkComment();
    }, []);

    return (
        <div>
            <Form
                className="events-comment-form"
            >
                <Form.Group className='events-comment-group'>
                    <Form.Input
                        fluid
                        width={commentExists === true ? 2 : 2}
                        placeholder={commentExists === true ? ratingPlaceholder : "Rating"}
                        required={commentExists === true ? false : true}
                        defaultValue={commentExists === true ? ratingPlaceholder : ""}
                        pattern="[0-5]{1}"
                        title="Digit 0-5 where 0 is lowest and 5 is highest"
                        onChange={(e) =>
                            setRating(
                                e.target.form[0].value
                            )
                        }
                    />
                    <Form.Input
                        className='events-comment-input'
                        fluid
                        width={commentExists === true ? 12 : 14}
                        placeholder={commentExists === true ? commentPlaceholder : "Comment"}
                        defaultValue={commentExists === true ? commentPlaceholder : ""}
                        required={commentExists === true ? false : true}
                        onChange={(e) =>
                            setComment(
                                e.target.form[1].value
                            )
                        }
                    />
                    {commentExists === false ? 
                        (
                            <Button
                                className='events-post-comment-btn' 
                                onClick={(e) => postComment()}
                            >
                                POST
                            </Button>
                        ) : (
                            <Grid columns={2}>
                                <Grid.Column width={6}>
                                    <Button
                                        className='events-edit-comment-btn' 
                                        onClick={(e) => editComment()}
                                    >
                                        EDIT
                                    </Button>
                                </Grid.Column>
                                <Grid.Column width={6}>
                                    <Button
                                        className='events-delete-comment-btn' 
                                        onClick={(e) => deleteComment()}
                                    >
                                        DELETE
                                    </Button>
                                </Grid.Column>
                            </Grid>
                        )}
                </Form.Group>
            </Form>
        </div>
    )

    async function deleteComment() {
        try {
            let info = {
                eventid: eventid,
                userid: localStorage.getItem("userid")
            };

            let jsonObj = JSON.stringify(info);

            const response = await fetch(
                "https://student-org-events.herokuapp.com/PHP/deleteComment.php",
                {
                    method: "POST",
                    body: jsonObj,
                    header: { "Content-Type": "application/json" },
                }
            );

            var res = await response.json();

            if (res.error !== "") {
                console.log(res.error);
            }
            else {
                console.log("Comment deleted");
            }
        } catch (error) {
            console.log(error);
        }
    }

    async function editComment() {
        try {
            let info;
            if (comment === undefined && rating === undefined) {
                console.log("comment not changed");
                info = {
                    eventid: eventid,
                    userid: localStorage.getItem("userid"),
                    comment: commentPlaceholder,
                    rating: ratingPlaceholder
                };
            }
            else if (comment === undefined) {
                console.log("comment not changed");
                info = {
                    eventid: eventid,
                    userid: localStorage.getItem("userid"),
                    comment: commentPlaceholder,
                    rating: rating
                };
            }
            else if (rating === undefined) {
                console.log("rating not changed");
                info = {
                    eventid: eventid,
                    userid: localStorage.getItem("userid"),
                    comment: comment,
                    rating: ratingPlaceholder
                };
            }
            else {
                info = {
                    eventid: eventid,
                    userid: localStorage.getItem("userid"),
                    comment: comment,
                    rating: rating
                };
            }
            

            let jsonObj = JSON.stringify(info);

            const response = await fetch(
                "https://student-org-events.herokuapp.com/PHP/editComment.php",
                {
                    method: "POST",
                    body: jsonObj,
                    header: { "Content-Type": "application/json" },
                }
            );

            var res = await response.json();

            if (res.error !== "") {
                console.log(res.error);
            }
            else {
                console.log("Comment edited");
            }
        } catch (error) {
            console.log(error);
        }
    }

    async function checkComment() {
        try {
            let info = {
                eventid: eventid,
                userid: localStorage.getItem("userid"),
            };

            let jsonObj = JSON.stringify(info);

            const response = await fetch(
                "https://student-org-events.herokuapp.com/PHP/getComment.php",
                {
                    method: "POST",
                    body: jsonObj,
                    header: { "Content-Type": "application/json" },
                }
            );

            var res = await response.json();

            if (res.error !== "") {
                console.log(res.error);
                if (res.error === "User has not posted a comment for this event")
                    console.log("Do something");
            }
            else {
                setCommentExists(true);
                setCommentPlaceholder(res.results[0].comment);
                setRatingPlaceholder(res.results[0].rating);
            }
        } catch (error) {
            console.log(error);
        }
    }

    async function postComment() {
        console.log("eventid", eventid);
        try {
            let info = {
                eventid: eventid,
                userid: localStorage.getItem("userid"),
                comment: comment,
                rating: rating
            };

            let jsonObj = JSON.stringify(info);

            const response = await fetch(
                "https://student-org-events.herokuapp.com/PHP/createComment.php",
                {
                    method: "POST",
                    body: jsonObj,
                    header: { "Content-Type": "application/json" },
                }
            );

            var res = await response.json();

            if (res.error !== "") {
                console.log(res.error);
                if (res.error === "User already commented on this event")
                    console.log("Do something");
            }
            else {
                console.log("Comment created");
            }
        } catch (error) {
            console.log(error);
        }
    }
}
